import { useEffect } from 'react';
import { useRevealOnScroll } from '@/hooks/useScrollReveal';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import StatsSection from './components/StatsSection';
import MarketplacesSection from './components/MarketplacesSection';
import PriceCalculator from './components/PriceCalculator';
import WhyUsSection from './components/WhyUsSection';
import TestimonialsSection from './components/TestimonialsSection';
import CtaBanner from './components/CtaBanner';
import AirFreightSection from './components/AirFreightSection';

export default function HomePage() {
  useRevealOnScroll();
  useEffect(() => {
    document.title = 'CargoNet | Uluslararası Lojistik ve Kargo Taşımacılığı';
    window.scrollTo(0, 0);
  }, []);

  return (
    <main>
      <HeroSection />
      <PriceCalculator />
      <AirFreightSection />
      <ServicesSection />
      <StatsSection />
      <MarketplacesSection />
      <WhyUsSection />
      <TestimonialsSection />
      <CtaBanner />
    </main>
  );
}
